import { combineReducers } from '@reduxjs/toolkit';
import donation from '../slices/donation';

const rootReducer = combineReducers({
  donation,
});

export default rootReducer;
